<p-dialog
  [(visible)]="visible"
  [modal]="true"
  styleClass="w-[45rem] introduction-dialog"
  contentStyleClass="px-10 pb-10 pt-8 flex flex-col gap-10 rounded-b-2xl relative min-h-[16.5rem]"
>
  <ng-template pTemplate="header">
    <h4>What's Next?</h4>
  </ng-template>

  <ng-template pTemplate="content">
    @if (loaded()) {
      @if (pendingPartnership()) {
        <app-pending-partnership-message
          [partnership]="pendingPartnership()!"
          (viewAgreement)="navigateToAgreement()"
        />
      }
      <div class="flex flex-col gap-6">
        @for (item of items(); track $index) {
          <a
            class="flex items-center justify-between cursor-pointer"
            (click)="navigateToItem(item)"
          >
            <div class="flex items-center gap-4">
              <span
                class="material-symbols-rounded text-2xl leading-6 p-3 rounded-lg bg-purple-1"
                >{{ item.icon }}</span
              >
              <div class="flex flex-col">
                <span class="button-2-semibold text-navy">{{
                  item.title
                }}</span>
                @if (item.subtitle) {
                  <span class="body-1-regular text-navy">{{
                    item.subtitle
                  }}</span>
                }
              </div>
            </div>
            <span class="material-symbols-rounded text-2xl leading-6"
              >arrow_forward</span
            >
          </a>
        }
      </div>
    } @else {
      <app-loader loaderStyleClasses="absolute w-full h-full" />
    }
  </ng-template>
</p-dialog>
